export {}

async function loadBaseForm() {
  if (document.querySelectorAll("form.--validate").length) {
    await import("@components/base-form/base-form")
  }
}
loadBaseForm()

async function loadTextField() {
  if (document.querySelectorAll(".f-text, .f-textarea").length) {
    await import("@components/fields/text-field/text-field")
  }
}
loadTextField()

async function loadFieldsetTogglers() {
  if (document.querySelectorAll(".i-fieldset-toggle").length) {
    await import("@components/items/fieldset-toggle-item/fieldset-toggle-item")
  }
}
loadFieldsetTogglers()

async function loadDynamicFieldset() {
  if (document.querySelectorAll(".i-dynamic-fieldset").length) {
    await import("@components/items/dynamic-fieldset-item/dynamic-fieldset-item")
  }
}
loadDynamicFieldset()

async function loadSlimSelect() {
  if (document.querySelectorAll(".slim-select").length) {
    await import("./js/slim-select/slim-select")
  }
}
loadSlimSelect()

async function loadTippy() {
  if (document.querySelectorAll(".--tippy, [data-tippy-content]").length) {
    await import("./js/tippy")
  }
}
loadTippy()

async function loadIcoField() {
  if (document.querySelectorAll(".f-ico").length) {
    await import("@components/fields/ico-field/ico-field")
  }
}
loadIcoField()

async function loadInteractiveFormTax() {
  if (document.querySelectorAll(".f-interactive-tax").length) {
    await import("@components/forms/interactive-form/interactive-form--tax")
  }
}
loadInteractiveFormTax()

async function loadInteractiveForm() {
  if (document.querySelectorAll(".f-interactive").length) {
    await import("@components/forms/interactive-form/interactive-form")
  }
}
loadInteractiveForm()

async function loadSwiper() {
  if (document.querySelectorAll(".swiper").length) {
    await import("./js/swiper/swiper")
  }
}
loadSwiper()

async function loadFancybox() {
  await import("./js/fancybox/fancybox")
}
loadFancybox()

async function loadIMask() {
  if (document.querySelectorAll(".--number-mask").length) {
    await import("./js/imask/imask")
  }
}
loadIMask()

async function loadInteractiveFormRecalculation() {
  if (document.querySelectorAll(".f-toggle-input-radios").length) {
    await import("@components/forms/interactive-form/interactive-form--toggle-input-radios")
  }
}
loadInteractiveFormRecalculation()

async function loadInteractiveFormCalculatedExpences() {
  if (document.querySelectorAll(".f-calculated-expences").length) {
    await import("@components/forms/interactive-form/interactive-form--calculated-expences")
  }
}
loadInteractiveFormCalculatedExpences()
